var map = {
	"./en/about.json": 4048,
	"./en/advantages.json": 2165,
	"./en/base.json": 6146,
	"./en/blockquote.json": 4472,
	"./en/cta.json": 3951,
	"./en/ctaFooter.json": 5796,
	"./en/features.json": 8364,
	"./en/footer.json": 7184,
	"./en/form.json": 7517,
	"./en/hero.json": 8247,
	"./en/panel.json": 9291,
	"./en/partners.json": 316,
	"./en/steps.json": 4842,
	"./en/successPage.json": 2537,
	"./pl/about.json": 5223,
	"./pl/advantages.json": 4704,
	"./pl/base.json": 2851,
	"./pl/blockquote.json": 4225,
	"./pl/cta.json": 3600,
	"./pl/ctaFooter.json": 5515,
	"./pl/features.json": 6077,
	"./pl/footer.json": 1549,
	"./pl/form.json": 7496,
	"./pl/hero.json": 530,
	"./pl/panel.json": 3884,
	"./pl/partners.json": 7381,
	"./pl/steps.json": 3113,
	"./pl/successPage.json": 6862,
	"./ua/about.json": 4841,
	"./ua/advantages.json": 4390,
	"./ua/base.json": 9505,
	"./ua/blockquote.json": 515,
	"./ua/cta.json": 4110,
	"./ua/ctaFooter.json": 9905,
	"./ua/features.json": 5759,
	"./ua/footer.json": 5027,
	"./ua/form.json": 6850,
	"./ua/hero.json": 792,
	"./ua/panel.json": 6242,
	"./ua/partners.json": 539,
	"./ua/steps.json": 6531,
	"./ua/successPage.json": 1704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7189;